
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LineChart, HeartPulse } from 'lucide-react';
import { ArtistHealthCheck } from '@/types';
import CareerHealthTabContent from './tabs/CareerHealthTabContent';
import MentalWellnessTabContent from './tabs/MentalWellnessTabContent';

interface ArtistHealthDashboardProps {
  healthCheck: ArtistHealthCheck;
  onRequestUpdate: () => void;
}

const ArtistHealthDashboard: React.FC<ArtistHealthDashboardProps> = ({ 
  healthCheck,
  onRequestUpdate 
}) => {
  const [activeTab, setActiveTab] = useState('career');
  const [resetModalOpen, setResetModalOpen] = useState(false);
  
  return (
    <div className="space-y-6">
      <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid grid-cols-2 mb-4">
          <TabsTrigger value="career" className="flex items-center gap-2">
            <LineChart className="h-4 w-4" />
            <span>Career Health</span>
          </TabsTrigger>
          <TabsTrigger value="wellness" className="flex items-center gap-2">
            <HeartPulse className="h-4 w-4" />
            <span>Mental Wellness</span>
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="career">
          <CareerHealthTabContent 
            healthCheck={healthCheck}
            onRequestUpdate={onRequestUpdate}
          />
        </TabsContent>
        
        <TabsContent value="wellness">
          <MentalWellnessTabContent
            onResetModalOpen={() => setResetModalOpen(true)}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ArtistHealthDashboard;
